<template>
    <div class="bo-textarea-word-count">
        <textarea
            class="form-control"
            v-model="input"
            name="input"
            id="input"
            :rows="rows"
        ></textarea>
        <label class="counter"
            >{{ wordCount }} Word<span v-if="wordCount > 1">s</span></label
        >
    </div>
</template>


<script>
export default {
    props: {
        rows: {
            type: String,
            default: "4",
        },
    },
    data: function () {
        return {
            input: "",
        };
    },
    computed: {
        wordCount() {
            var vm = this,
                filecont = vm.input;
            return (
                vm.skip_html &&
                    (filecont = filecont.replace(/<\S[^><]*>/gi, "")),
                vm.input.match(/\w+/g) ? vm.input.match(/\w+/g).length : 0
            );
        },
    },
};
</script>